import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { upperFirst } from 'lodash';
import { css, styled } from 'styled-components';
import { Box } from "../../box/src";
import { FontAwesomeIcon } from "../../font-awesome-icon/src";
import { s__ } from "../../i18n/src";
import { DefaultLinkSimple } from "../../link/src";
import { primaryShadow } from "../../theme/src";
import { SUPPORTED_ICONS } from './utils';
export const SocialButton = (_a) => {
    var { dataTestId, title = '', type, url } = _a, otherProps = __rest(_a, ["dataTestId", "title", "type", "url"]);
    const socialName = upperFirst(type);
    const iconProps = SUPPORTED_ICONS[type];
    const testId = dataTestId || 'ds-m-social-button';
    let linkTitle = socialName;
    if (title) {
        linkTitle = s__('SocialLinks|%{title} on %{social_network}').i__({
            social_network: socialName,
            title,
        });
    }
    if (Object.keys(SUPPORTED_ICONS).includes(type)) {
        if (url) {
            return (_jsx(ButtonLink, Object.assign({ "data-testid": testId, href: url, target: "_blank", title: linkTitle }, otherProps, { children: _jsx(FontAwesomeIcon, { "data-testid": testId, height: "16px", iconName: iconProps.iconName, iconType: iconProps.iconType }) })));
        }
        return (_jsx(ButtonIcon, Object.assign({ "data-testid": testId, title: title }, otherProps, { children: _jsx(FontAwesomeIcon, { "data-testid": testId, height: "16px", iconName: iconProps.iconName, iconType: iconProps.iconType }) })));
    }
    return (_jsx(DefaultLinkSimple, Object.assign({ "data-testid": testId, href: url, target: "_blank", title: linkTitle }, otherProps, { children: title })));
};
const BaseButton = css `
  ${primaryShadow}
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  transition: background 300ms ease;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};

  &:focus,
  &:hover {
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }
`;
const ButtonLink = styled(DefaultLinkSimple) `
  ${BaseButton}
`;
const ButtonIcon = styled(Box) `
  ${BaseButton}
`;
//# sourceMappingURL=SocialButton.js.map